export const environment = {
  production: true,
  buildId: '3791330176323451',
  configFile: 'config.json',
};
